import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-somthng-wrong",
    templateUrl: "./somthng-wrong.component.html",
    styles: [],
    standalone: false
})
export class SomthngWrongComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
